import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getHotelsInput,
  getHotelInput,
  HotelLiteModel,
  HotelModel,
} from './model';

export function useGetHotels(
  input?: getHotelsInput,
  options?: UseQueryOptions<ExtendedApiResult<HotelLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<HotelLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getHotels', input?.params],
      () =>
        QueryFetchFunction({
          url: 'hotels',
          params: input?.params,
        }),
      options,
    ),
    HotelLiteModel,
  );
}

export function useGetHotel(
  input?: getHotelInput,
  options?: UseQueryOptions<ApiResult<HotelModel>, ApiError>,
): UseQueryResult<ApiResult<HotelModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getHotel', input?.id],
      () => QueryFetchFunction({ url: `hotels/${input?.id}` }),
      options,
    ),
    HotelModel,
  );
}

export function getHotelsKey(input?: getHotelsInput) {
  return ['getHotels', input?.params];
}

export function getHotelKey(input?: getHotelInput) {
  return ['getHotel', input?.id];
}
